import { render } from "./TenderDetail.vue?vue&type=template&id=096175e5"
import script from "./TenderDetail.vue?vue&type=script&lang=js"
export * from "./TenderDetail.vue?vue&type=script&lang=js"

import "./TenderDetail.vue?vue&type=style&index=0&id=096175e5&lang=css"
import "./TenderDetail.vue?vue&type=style&index=1&id=096175e5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__